import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import Login from './views/Login.vue';
import Events from './views/Events.vue';

Vue.use(Router);

export default new Router({
    base: process.env.BASE_URL,
    routes: [{
        path: '/login',
        name: 'login',
        component: Login,
    }, {
        path: '/events',
        name: 'eventlist',
        component: Events,
        meta: { loggedIn: true },
    }, {
        path: '/events/:path',
        name: 'eventselection',
        component: Events,
        meta: { loggedIn: true },
    }, {
        path: '*',
        name: 'home',
        component: Home,
    }],
});
